import { Link, graphql, useStaticQuery } from "gatsby";
import React from "react";
import TabbedContentBlade, { ITabContent } from "@organic-return/foundation-react/src/components/Blades/TabbedContentBlade";
import { EListingCardLayouts, ListingCard } from "@organic-return/foundation-react/src/components/Listing/ListingCard"
import { useSiteContext } from "../common/SiteContext";

const ListingsTabs = ({ module }) => {
  const data = useStaticQuery(graphql`
    query {
      allAgilityListingsTabs {
        nodes {
          contentID
          tabs {
            customFields {
              title
            }
            listings {
              price
              path
              address {
                text
                street1
                street2
                city
                county
                country
                state
                postal
              }
              baths
              beds
              lotacres
              sqft
              status
              defaultImage {
                url
                dimensions
              }
              type
              flags
            }
          }
        }
      }
    }
  `)
  const siteContext = useSiteContext()
  const fields = module.customFields

  let tabContent: ITabContent[] = []
  const agilityListingTabs = data.allAgilityListingsTabs?.nodes?.find(x => x.contentID == module.contentID)
  if (agilityListingTabs && agilityListingTabs.tabs && agilityListingTabs.tabs.length > 0) {
    tabContent = agilityListingTabs.tabs.map(item => {
      let tab: ITabContent = {
        tabTitle: item.customFields.title,
        content: (
          <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-7 gap-y-2.5">
            {item.listings && item.listings.map(listing => (
              <ListingCard
                layout={EListingCardLayouts.vertical}
                listing={listing}
                linkImage={true}
                linkFunc={props => {
                  return (
                    <Link
                      to={props.href ?? ""}
                      className={`text-inherit ${props.className}`}
                      key={props.key}
                      title={props.title}
                    >
                      {props.children}
                    </Link>
                  )
                }}
                {...siteContext.globalListingCardProps}
              />
            ))}
          </div>
        )
      }
      return tab
    });
  }

  return (
    <TabbedContentBlade
      className="relative w-full max-w-screen-xl mx-auto px-2 md:px-7"
      tabListClassName="gap-x-5 lg:gap-x-14"
      tabListItemClassNames={{
        default: "!w-auto md:!w-auto lg:!w-auto",
        active: "!w-auto md:!w-auto lg:!w-auto border-b border-body-bg-inverted"
      }}
      title={fields.title}
      secondaryTitle={fields.secondaryTitle}
      tabs={tabContent}
    />
  )
}

export default ListingsTabs